import React from "react";
import Link from "next/link";
import { FaShare } from "react-icons/fa";

export default function Navbar({ setShareLinksModal }) {
  return (
    <div className="bg-[#21252A] w-full sticky -top-2 z-20">
      <div className="flex-1 flex justify-center items-center pb-2 pt-3 lg:my-0 ">
        <Link href="/">
          <img
            aria-hidden
            src="/images/Logo-white.png"
            className="h-14 cursor-pointer relative top-0.5"
            alt="Snacktime"
          />
        </Link>
        <div className="bg-gray-100 rounded-full p-2 absolute right-4 cursor-pointe">
          <FaShare
            className="text-black"
            onClick={() => setShareLinksModal(true)}
          />
        </div>
      </div>
    </div>
  );
}
